import React, { useRef, useState } from "react";
import styles from "./LocationSelect.module.scss";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import colors from "../../../../styles/variables.module.scss";
import {
  useUbicationFilterContext,
  zoneI,
} from "../../../../hooks/UbicationFilterContext";
import { useAppDispatch, useAppSelector } from "../../../../hooks/reduxHooks";
import {
  selectBorderColor,
  selectSearchHotel,
} from "../../../../redux/slices/enviromentSlice/EnviromentSlice.selectors";
import {
  Autocomplete,
  Box,
  Menu,
  PopoverActions,
  TextField,
} from "@mui/material";
import { useHotelDataContext } from "../../../../hooks/HotelDataContextHook";
import { setSearchHotel } from "../../../../redux/slices/enviromentSlice/EnviromentSlice";
import LocationDropdown from "./components/locationDropdown/LocationDropdown";
import { useWidgetConfigContext } from "src/contexts/widgetConfig/WidgetConfig.context";
import CustomMenu from "../../../customMenu/CustomMenu";

interface propsI {
  onChangeUbication?: (ubication: zoneI) => void;
  ubication?: zoneI;
}

const LocationSelect: React.FC<propsI> = ({ onChangeUbication, ...props }) => {
  // redux hooks
  const dispatch = useAppDispatch();
  const borderColor = useAppSelector(selectBorderColor);
  const searchHotel = useAppSelector(selectSearchHotel);
  const { showSearchHotelInput } = useWidgetConfigContext();

  // context hooks
  const { ubicationFilterList } = useUbicationFilterContext();
  const { hotelDataList } = useHotelDataContext();

  const [openDropdown, setOpenDropdown] = useState(false);
  const anchorElRef = useRef(null);
  const popoverActionRef = useRef<PopoverActions>(null);

  const { t } = useTranslation();

  const [ubication, setUbication] = useState<zoneI | undefined>(
    props.ubication || ubicationFilterList[0]
  );

  useEffect(() => {
    setUbication(
      renderLists(ubicationFilterList).find(
        (ubicationFilter) => ubicationFilter.id === ubication?.id
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const hotelOptionList = hotelDataList.map(({ id, name }) => ({
    id,
    label: name,
  }));

  const selectedHotelOption = hotelOptionList.find(
    ({ id }) => id === searchHotel
  );

  const renderLists = (filterList: zoneI[]) => {
    const list: Array<zoneI> = filterList.reduce((acum, filterZone) => {
      acum = [...acum, filterZone];
      if (filterZone.hotelDataList?.length) {
        filterZone.hotelDataList.map((hotel) => {
          return (acum = [...acum, hotel]);
        });
      }
      if (filterZone.zoneDataList) {
        acum = [...acum, ...renderLists(filterZone.zoneDataList)];
      }
      return acum;
    }, [] as Array<zoneI>);
    return list;
  };

  const handleSelectHotel = (value: { id: string; label: string } | null) => {
    dispatch(setSearchHotel(value?.id));
  };

  const handleOpenDropdown = (event: React.MouseEvent) => {
    event.preventDefault();
    setOpenDropdown(!openDropdown);
  };

  const handleSelectUbication = (ubicationFilter: zoneI) => {
    if (onChangeUbication) onChangeUbication(ubicationFilter);
    setUbication(ubicationFilter);
    setOpenDropdown(false);
  };

  return (
    <div
      className={styles.mainContainer}
      ref={anchorElRef}
      style={{ borderColor: borderColor }}
    >
      <div className={styles.locationDropdown}>
        <div
          className={`${styles.locationDropdownBox}`}
          onClick={handleOpenDropdown}
        >
          <div className={styles.icon}>
            <img
              src="https://booking.availroom.com/v2/assets/icons/search.svg"
              alt=""
            />
          </div>
          <div className={styles.container}>
            <div
              className={styles.label}
              style={{
                color: colors.textLightgray,
              }}
            >
              {t("labels.selectedLocation")}
            </div>
            <div className={styles.selectedValue}>
              {selectedHotelOption?.label ?? ubication?.name}
            </div>
          </div>
          <div
            className={`${styles.dropdownIcon} ${
              openDropdown && styles.dropdownIconOpen
            }`}
          >
            <img
              src="https://booking.availroom.com/v2/assets/icons/dropdown.svg"
              alt=""
            />
          </div>
        </div>
        <div>
          <CustomMenu
            anchorEl={anchorElRef.current}
            open={openDropdown}
            onClose={() => setOpenDropdown(false)}
            popoverActionRef={popoverActionRef}
            slotProps={{
              paper: {
                sx: {
                  width: 300,
                },
              },
            }}
          >
            <div className={styles.dropdownSelectContainer}>
              {showSearchHotelInput && (
                <Box
                  sx={{
                    padding: "1rem",
                  }}
                >
                  <Autocomplete
                    options={hotelOptionList}
                    value={selectedHotelOption ?? null}
                    onChange={(_e, newVal) => handleSelectHotel(newVal)}
                    renderInput={(params) => (
                      <TextField label={t("labels.name")} {...params} />
                    )}
                  />
                </Box>
              )}
              <LocationDropdown
                onSelectUbication={handleSelectUbication}
                popoverActionRef={popoverActionRef}
              />
            </div>
          </CustomMenu>
        </div>
      </div>
    </div>
  );
};

export default LocationSelect;
